<script>
/**
 * Example:
 * <editable-row
 *   column-names="[{name:'a',editable:false},'b','c']"
 *   values="[1,2,3]"
 *   save="(key,value)=>bool"
 *  />
 */
const props = {
  values: {
    type: Array,
    required: true
  },
  columnNames: {
    type: Array,
    required: true
  },
  save: Function //(key,value)->boolean
};
function data() {
  return {};
}
const computed = {
  widths() {
    if (this.columnNames.length == 2) {
      return [20, 80];
    }
    return new Array(
      this.columnNames.length,
      Math.floor(100 / this.columnNames.length)
    );
  }
};
const methods = {
  onSave(index, value) {
    let oldValue = this.values[index];
    if (value !== oldValue) {
      return this.save(index, value);
    }
    return false;
  },
  getSave(index) {
    return this.onSave.bind(this, index);
  }
};
import EditableListCell from "./EditableListCell";
const components = {
  "editable-list-cell": EditableListCell
};

export default {
  props,
  data,
  computed,
  components,
  methods
};
</script>

<template>
  <tr>
    <editable-list-cell
      v-for="(v,k) in values"
      :key="`cell-${k}`"
      :data="v.split(',').filter(d=>d != '')"
      pattern="^\d+$"
      :width="widths[k]"
      :editable="columnNames[k].editable"
      :change="getSave(k)"
    />
  </tr>
</template>
<style scoped>
td {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// EditableRow.vue?7a0e3389